<template>
  <div>
    <el-dialog title="预约开户" :visible.sync="dialogFormVisible" width="500px" center class="elform2" :close-on-click-modal="false" @close="closeDialog" @open="opendia">
      <div v-loading="loading">
        <el-form :model="ruleForm" ref="ruleForm" label-width="140px" :center="true" class="demo-ruleForm" :rules="bankRules">
          <el-form-item label="预约开户银行" prop="bank">
            <el-select v-model="ruleForm.bank" placeholder="请选择" size="small" style="width: 300px;">
              <el-option v-for="(item,index) in banklist" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业名称" prop="entName">
            <el-input v-model="ruleForm.entName" placeholder="请输入" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="socialCreditCode">
            <el-input v-model="ruleForm.socialCreditCode" placeholder="请输入" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="企业类型" prop="conpanyType">
            <el-select v-model="ruleForm.conpanyType" placeholder="请选择" size="small" style="width: 300px;">
              <el-option label="合资" value="合资"></el-option>
              <el-option label="独资" value="独资"></el-option>
              <el-option label="国有" value="国有"></el-option>
              <el-option label="私营" value="私营"></el-option>
              <el-option label="全民所有制" value="全民所有制"></el-option>
              <el-option label="集体所有制" value="集体所有制"></el-option>
              <el-option label="股份制" value="股份制"></el-option>
              <el-option label="有限责任制" value="有限责任制"></el-option>
              <el-option label="工厂" value="工厂"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法定代表人姓名" prop="signName">
            <el-input v-model="ruleForm.signName" placeholder="请输入" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="tel">
            <el-input v-model="ruleForm.tel" placeholder="请输入11位手机号" size="small" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="confirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="预约开户"
      :visible.sync="iframedialog"
       center
       width="1200px"
       :close-on-click-modal="false">
      <iframe :src="iframeurl" frameborder="0" width="100%" height="650px" scrolling="auto"></iframe>
      <!-- <div v-html="iframeurl"></div> -->
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'Axios'
  import qs from 'qs'
  export default {
    props: ['visible'],
  	data(){
      var xydm = (rule, value, callback) => {
        let exp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;
        if (!exp.test(value)) {
          return callback(new Error('请输入正确的统一社会信用代码!'));
        }else{
          callback();
        }
      };
      var phoneNumber = (rule, value, callback) => {
        let exp = /^1\d{10}$/;
        if(value != '' && value != null){
          if (!exp.test(value)) {
            return callback(new Error('请输入正确的联系电话!'));
          }else{
            callback();
          }
        }else{
          callback();
        }
      };
  		return {
        loading:false,
        dialogFormVisible:false,
        iframedialog:false,
        banklist:[],
        iframeurl:'',
        ruleForm:{
          bank:'',
          entName:'',
          conpanyType:'',
          signName:'',
          tel:'',
          socialCreditCode:''
        },
        bankRules:{
          bank:[{required:true,message:'请选择预约开户银行！'}],
          entName:[{required:true,message:'请输入企业名称！'}],
          conpanyType:[{required:true,message:'请选择企业类型！'}],
          signName:[{required:true,message:'请输入法定代表人姓名！'}],
          socialCreditCode:[{required:true,message:'请输入统一社会信用代码！'},{validator: xydm, trigger: 'blur'}],
          tel:[{validator: phoneNumber, trigger: 'blur'}]
        }
  		}
  	},

  	computed: {

  	},
  	methods:{
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
      opendia(){
        this.loading=true
        this.$http.post('/sys/dict/list',{type:'bank'}).then((res)=>{
          this.loading=false
          console.log(res)
          if(res && res.data.code == '1'){
            this.banklist=res.data.data
          }
        })
      },
      confirm(){
        this.$refs.ruleForm.validate(valid=>{
          if(valid){
            let baseURL=this.$rootUrl;
            let token = sessionStorage.getItem('token')
            let cid = sessionStorage.getItem('cid')
            this.dialogFormVisible=false
            this.iframedialog=true
            this.iframeurl=baseURL+'bankOpenAccount/openAccount?token='+token+'&cid='+cid+"&"+qs.stringify(this.ruleForm,{arrayFormat: 'indices', allowDots: true})
          }
        });
      }
  	},
    watch: {
  　　visible: {
　　　　handler(newValue, oldValue) {
          console.log(newValue)
          if(newValue.showdialog){
            this.dialogFormVisible=true;
            this.ruleForm = Object.assign(this.ruleForm,{
              bank:'',
              entName:'',
              conpanyType:'',
              signName:'',
              tel:'',
              socialCreditCode:''
            });
          }
　　　　},
　　　　deep: true,
       immediate: true
  　　},

    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/bankwater/openAccount.vue